import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every route change: scroll to top — unless the URL carries a #hash, in
 * which case scroll to that element. Pages are lazy-loaded, so the target may
 * not exist on the first frame; retry briefly until it renders.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = hash.slice(1);
    let attempts = 0;
    let timer: number | undefined;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (attempts++ < 40) {
        timer = window.setTimeout(tryScroll, 50);
      }
    };

    tryScroll();
    return () => {
      if (timer !== undefined) window.clearTimeout(timer);
    };
  }, [pathname, hash]);

  return null;
}
